/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import * as React from 'react';
import { MediaContext } from '../../../../MediaContext';
import { useHeadingSectionIndexedMeasure } from './hooks';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: ouiStyle.Constants.DisplayProp.flex,
  flexDirection: [ouiStyle.Constants.InFlexDirectionProp.col, undefined, undefined, ouiStyle.Constants.InFlexDirectionProp.row, undefined, undefined],
  alignItems: ouiStyle.Constants.AlignItemsProp.center,
  justifyContent: ouiStyle.Constants.JustifyContentProp.between,
};

const css = ouiStyle.mediaQuery(ouiStyle.makeCss(style));

export const MeasuredMultiIllustrationContainer = (props: React.PropsWithChildren<{
  height: number,
  setHeight: any,
}>) => {
  const {
    height,
    setHeight,
    children,
  } = props;
  const [observe] = useHeadingSectionIndexedMeasure(setHeight);
  const { upMd } = React.useContext(MediaContext);
  return (
    <div
      style={upMd ? {
        height,
      } : {}}
    >
      <div
        ref={observe}
        css={css}
      >
        {children}
      </div>
    </div>
  );
};
